import session from '@/services/session'
import { receiveMsgHistory, receiveMsgHistoryV2, receiveMsgHistoryV3 } from '@/services/webhook/webhook'
import AppError from '@/services/errors/app-errors'
import { userMessageParser } from '@/services/parser/userMessageParser'
import { botResponseMessageParser } from '@/services/parser/botResponseParser'
import { hasConversationInitiated, getIdleTimeout, isTypeBOT, isUserLoggedIn, extractQuickReplyOptions, handleIfConversationIdNull, isOauthEnabled, isChatNotStarted, isMultiSourceLastExtension } from '@/services/utils'
import { constantStrings, chatEvents, cookieConstant } from '@/services/constants'
import { extractNBAOptions, blankScreenCheck, removeConversationBeforeRestart, checkIfRequestIdExists, getPreviousTimestamp, isfullHistoryLoaded } from '../../services/utils'
import eventParser from '@/services/parser/eventParser'
import Storage from '@/services/storageLib'
import { getUrlData } from '../../services/urlDetails/urlInfo'
import { getCookie, setAllCookiesInVueStore } from '../../services/cookie'
import store from '..'
import { isSensitiveDataMaskingEnabled } from '../actions/chatMessages_ac'
import cloneDeep from 'lodash/cloneDeep'
import { maskSensitiveData } from '../../services/crypto/index'
import { AUTH_CONSTANTS } from '@/constants/authentication' 

export default {
  async receiveHistoryOfMessages({ commit, dispatch, rootState }) {
    try {
      const hasChatStarted = isUserLoggedIn() ||  hasConversationInitiated() || isOauthEnabled()
      if(hasChatStarted || rootState?.widgetConfig?.fixedConversationId) {
        const { widgetConfig } = rootState
        const chatHistory = widgetConfig.chatHistory
        const conversationId = session.getConversationId(widgetConfig) || getCookie(cookieConstant.SESSION.CONVERSATION_ID)
        handleIfConversationIdNull('ConversationId invalid error is received from history API', true)
        validateRequiredFieldsHistoryMessages(conversationId)
        const payload = {conversationId, 
        requestBody : {
          numberOfMessages: chatHistory?.numberOfMessages || 100,
          numberOfDays: chatHistory?.numberOfDays || 10
        }, botRefId: rootState.botRefId}
        let additionalHeaders = {}
        if (!rootState.externalId) {
          const userDetails = JSON.parse(localStorage.getItem(AUTH_CONSTANTS.USER_DETAILS) || '{}') // Default to empty object
          rootState.externalId = userDetails?.externalId || userDetails?.userId || '' // Ensure it's a valid value
        }
        additionalHeaders['x-external-id'] = rootState.externalId
        const messageHistory = await receiveMsgHistoryV3(constantStrings.UNMASKED, payload, additionalHeaders)
        removeConversationBeforeRestart(messageHistory);
        
        commit('UPDATE_HISTORY_LOADING_STATUS', true)
        dispatch('processWebhookHistoryResponse', messageHistory?.data)
        rootState.previousTimestamp = getPreviousTimestamp(messageHistory, chatHistory?.numberOfMessages || 100, rootState.previousTimestamp)
        if(isfullHistoryLoaded(messageHistory, chatHistory?.numberOfMessages || 100)) {
          const previousConversationId = getPreviousConversationId(messageHistory)
          if(previousConversationId) {
            rootState.previousConversationId = conversationId
            rootState.currentCoversationId = previousConversationId
          } else {
            rootState.isfullHistoryLoaded = true
            rootState.currentCoversationId = ''
          }
        }
        // Check for blank screen
        blankScreenCheck(constantStrings.EMPTY_HISTORY_CALL)
        commit('SANITIZE_CHAT_HISTORY_FOR_FORMS')
        setAllCookiesInVueStore()
        // Reset the End chat and overlay ideal timer after referesh
        const lastConversationCreatedAt = session.createdAt
        const delay = (getIdleTimeout()) - (new Date().getTime() - lastConversationCreatedAt) // set timer for the remaining time left from idleTimeout
        dispatch('setEndChatTimer', {delay, isGuest: !isUserLoggedIn()}) // start the idle timer on page refresh
        dispatch('throttleAgentDeskConnectionIdleTimeout', store.getters.getAgentDeskIdleTimeout - (new Date().getTime() - lastConversationCreatedAt))
        await dispatch('setIdleTimerForSurvey') // set idle timer for survey form triggering
        dispatch('overlayIdleChatTimeout')
        if (rootState.widgetConfig.persistentSurveyConfig?.isPersistentSurveyEnabled) {
          dispatch('updateCSATState', { isEnabled: true })
        }
      }
    } catch (err) {
      console.log('Error Receiving History of Messages', err.message)
      throw new AppError({name: 'Action', message:`Error Receiving History of Messages. ${err.message}`})
    } finally {
      commit('UPDATE_HISTORY_LOADING_STATUS', false)
      dispatch('updatePreLoaderEnabledStatus', false)
    }
  },

  async receiveHistoryOfMessagesV3 ({commit, dispatch, rootState}) {
    try {
      const hasChatStarted = isUserLoggedIn() ||  hasConversationInitiated() || isOauthEnabled()
      if(hasChatStarted || rootState?.widgetConfig?.fixedConversationId) {
        const { widgetConfig } = rootState
        const chatHistory = widgetConfig.chatHistory
        const conversationId = session.getConversationId(widgetConfig) || getCookie(cookieConstant.SESSION.CONVERSATION_ID)
        handleIfConversationIdNull('ConversationId invalid error is received from history API', true)
        validateRequiredFieldsHistoryMessages(conversationId)
        let requestConversationId = conversationId
        if(rootState?.externalId && rootState?.currentCoversationId) {
          requestConversationId = rootState.currentCoversationId
        }
        const payload = {
            conversationId: requestConversationId,
            requestBody : {
              numberOfMessages: chatHistory?.numberOfMessages || 100,
              numberOfDays: chatHistory?.numberOfDays || 10
          },
          botRefId: rootState.botRefId
        }
        let additionalHeaders = {}
        if (!rootState.externalId) {
          const userDetails = JSON.parse(localStorage.getItem(AUTH_CONSTANTS.USER_DETAILS) || '{}'); // Default to empty object
          rootState.externalId = userDetails?.externalId || userDetails?.userId || ''; // Ensure it's a valid value
        }
        additionalHeaders['x-external-id'] = rootState.externalId
        if(rootState.previousTimestamp) {
          payload.requestBody['timestamp'] = rootState.previousTimestamp
        }
        const messageHistory = await receiveMsgHistoryV3(constantStrings.UNMASKED, payload, additionalHeaders)
        let chats = [...(messageHistory?.data?.responses || [])].reverse()
        messageHistory.data.responses = chats
        
        messageHistory.data.isPreviousHistory = true
        dispatch('processWebhookHistoryResponse', messageHistory?.data)
        if(isfullHistoryLoaded(messageHistory, chatHistory?.numberOfMessages || 100)) {
          const previousConversationId = getPreviousConversationId(messageHistory)
          if(previousConversationId) {
            rootState.previousConversationId = rootState.currentCoversationId
            rootState.currentCoversationId = previousConversationId
            rootState.previousTimestamp = getPreviousTimestamp(messageHistory, chatHistory?.numberOfMessages || 100, rootState.previousTimestamp) || rootState.previousTimestamp
            commit('SANITIZE_CHAT_HISTORY_FOR_FORMS')
            return
          } else {
            rootState.isfullHistoryLoaded = true
            rootState.currentCoversationId = ''
            commit('SANITIZE_CHAT_HISTORY_FOR_FORMS')
            return
          }
        }
        rootState.previousTimestamp = getPreviousTimestamp(messageHistory, chatHistory?.numberOfMessages || 100, rootState.previousTimestamp)
        // Check for blank screen
        blankScreenCheck(constantStrings.EMPTY_HISTORY_CALL)
        commit('SANITIZE_CHAT_HISTORY_FOR_FORMS')
        if(!rootState.previousCoversationLoader) {
          commit('UPDATE_PREVIOUS_CONVERSATION_LOADER', true)
        }
      }
    } catch (err) {
      console.log('Error Receiving History of Messages', err.message)
      throw new AppError({name: 'Action', message:`Error Receiving History of Messages. ${err.message}`})
    } finally {
      commit('UPDATE_PREVIOUS_CONVERSATION_LOADER', false)
    }
  },

  async receiveMaskedHistoryOfMessages({ rootState, commit }) {
    try {
      const { widgetConfig } = rootState
      const chatHistory = widgetConfig.chatHistory
      const conversationId = session.getConversationId(widgetConfig) || getCookie(cookieConstant.SESSION.CONVERSATION_ID)
      handleIfConversationIdNull('ConversationId invalid error is received from history API', true)
      const payload = {
        conversationId,
        requestBody : {
          numberOfMessages: chatHistory?.numberOfMessages || 100,
          numberOfDays: chatHistory?.numberOfDays || 10
        },
        botRefId: rootState.botRefId
      }

      const messageHistory = await receiveMsgHistory(constantStrings.MASKED, payload)
      const data = messageHistory?.data?.responses
      const result = []
      data.forEach((response, index) => {
        const triggerType = response.triggerType
        if (triggerType === chatEvents.REQUEST) {
          const requestPayload = response.requestPayload
          const { messagePayload } = requestPayload
          const { text, label } = messagePayload
          const botPCIPolicy = rootState.botPCIPolicy || {}
          const shouldMask = isSensitiveDataMaskingEnabled(rootState) && !text.startsWith('event://;')
          let maskedRequestBody = requestPayload
          if (shouldMask) {
            const maskedText = maskSensitiveData(botPCIPolicy, text)

            const maskedLabel = (text !== label)
              ? maskSensitiveData(botPCIPolicy, label)
              : maskedText

            if (maskedText !== text || maskedLabel !== label) {
              maskedRequestBody = cloneDeep(requestPayload)
              maskedRequestBody.messagePayload.text = maskedText
              maskedRequestBody.messagePayload.label = maskedLabel

              commit('UPDATE_MASKED_VALUE_MAP', {
                messageId: maskedRequestBody.messagePayload.messageId,
                text,
                maskedText,
                label,
                maskedLabel
              })
            }
          }
          const userMessage = userMessageParser(shouldMask ? maskedRequestBody : requestPayload)
          result.push(userMessage)
        } else if (triggerType === chatEvents.RESPONSE) {
          const isLastBotResponse = Boolean(data?.length - 1 === index)
          const isAgentResponse = !isTypeBOT(response?.ownerType)
          response.timestamp = response.timestamp.toString()
          const botResponse = botResponseMessageParser(response, isLastBotResponse, isAgentResponse, true)
          result.push(botResponse)
        } else if (triggerType === chatEvents.EVENT) {
          if (response.eventObject.eventName === 'INFO_PILL') {
            result.push(response.eventObject)
          }
        }
      })
      return result
    } catch (err) {
      console.log('Error Receiving History of Messages', err.message)
      throw new AppError({name: 'Action', message:`Error Receiving History of Messages. ${err.message}`})
    }
  },

  async updateMissedMessagesFromHistory({ commit, rootState }) {
    try {
      const hasChatStarted = isUserLoggedIn() || hasConversationInitiated()
      if (!hasChatStarted) {
        return
      }
      const conversationId = getCookie(cookieConstant.SESSION.CONVERSATION_ID)
      const payload = {
        conversationId,
        requestBody : {
          numberOfMessages: 30,
          numberOfDays: 10
        },
        botRefId: rootState.botRefId
      }
      const messageHistory = await receiveMsgHistoryV2(constantStrings.UNMASKED, payload)
      const responses = messageHistory?.data?.responses
      let isSortValid = false
      const missedMessageRequestIds = []
      responses.forEach((response, index) => {
        const triggerType = response.triggerType
        const isAgentResponse = !isTypeBOT(response?.ownerType)
        if (triggerType === chatEvents.RESPONSE && isAgentResponse) {
          const isLastBotResponse = Boolean(responses?.length - 1 === index)
          response.timestamp = response.timestamp.toString()
          const botResponse = botResponseMessageParser(response, isLastBotResponse, isAgentResponse, true)
          botResponse.initiator = constantStrings.WEBHOOK_HISTORY
          const currentRequestId = botResponse.requestId
          if (!checkIfRequestIdExists(currentRequestId)) {
            commit('UPDATE_CHATS', botResponse)
            missedMessageRequestIds.push(botResponse?.requestId)
            isSortValid = true
          }
        }
      })
      isSortValid && commit('SORT_CHATS_ACC_TO_TIMESTAMP')
      return missedMessageRequestIds
    } catch (err) {
      console.log('Error Receiving History of Messages', err.message)
      throw new AppError({name: 'Action', message:`Error Receiving History of Messages. ${err.message}`})
    }
  },

  processWebhookHistoryResponse({ commit, dispatch, rootState }, data) {
    const lastResponse = data?.responses[data?.responses?.length - 1 ]
    const isLastResponseUser = !data?.isPreviousHistory && Boolean(lastResponse?.triggerType === chatEvents.REQUEST) //isLastResponseByUser
    const isLastResponseBot = !data?.isPreviousHistory && Boolean(lastResponse?.triggerType === chatEvents.RESPONSE) //isLastResponseByBot/Agent
    data.responses.forEach((response, index) => {
      try {
        const triggerType = response.triggerType
        const isLastBotResponse = !data?.isPreviousHistory && Boolean(data?.responses?.length - 1 === index) //LastMessageCanBeBotOrUser
        switch (triggerType) {
          case chatEvents.REQUEST:
            processRequestTriggerType(commit, dispatch, rootState, response.requestPayload, isLastResponseUser)
            break;
          case chatEvents.RESPONSE:
            processResponseTriggerType(commit, dispatch, rootState, response, isLastBotResponse, isLastResponseBot)
            break;
          case chatEvents.EVENT:
            processEventTriggerType(response.eventObject, data?.responses?.length - 1 === index)
            break;
          default:
            break;
        }
      } catch (error) {
        console.log(error)
      }
    })
  },

  async fetchHistory({ commit, dispatch, rootState }) {
    /* 
      IMP: Added session storage check for Multiple tabs to fetch history when user opens the 
      closed widget. userInteracted will be false initially per tab and once user opens it up,
      current chats in that tab will be cleared and latest history of chats will be fetched.
      it will be changed to true and further history calls from it within single session (without refresh).

      In case of widget in isDefaulOpened: true, flow will work same as earlier.
    */
   try {
     dispatch('updatePreLoaderEnabledStatus', true)
     if(isChatNotStarted() && !rootState.isHistoryLoading) {
       commit('UPDATE_HISTORY_LOADING_STATUS', true)
       await dispatch('receiveHistoryOfMessages')
     }
     else if(!Storage.getSessionStorageData('userInteracted') && !rootState.isHistoryLoading) {
       commit('UPDATE_HISTORY_LOADING_STATUS', true)
       commit('CLEAR_CHATS')
       await dispatch('receiveHistoryOfMessages')
     }
   } catch (error) {
      throw new AppError({
        name: 'History Fetching',
        message:'Error in fetching history',
        error
      })
   }
  },
  async fetchPreviousConversations({ commit, dispatch, rootState }) {
    /* 
      IMP: Added session storage check for Multiple tabs to fetch history when user opens the 
      closed widget. userInteracted will be false initially per tab and once user opens it up,
      current chats in that tab will be cleared and latest history of chats will be fetched.
      it will be changed to true and further history calls from it within single session (without refresh).
      In case of widget in isDefaulOpened: true, flow will work same as earlier.
    */
    try {
      if(!rootState.isHistoryLoading && !rootState.previousCoversationLoader) {
        commit('UPDATE_PREVIOUS_CONVERSATION_LOADER', true)
        await dispatch('receiveHistoryOfMessagesV3')
        commit('UPDATE_PREVIOUS_CONVERSATION_LOADER', false)
      }
    } catch (error) {
        throw new AppError({
          name: 'History Fetching',
          message:'Error in fetching history',
          error
        })
    } finally{
      commit('UPDATE_PREVIOUS_CONVERSATION_LOADER', false)
    }
  }
}

const processRequestTriggerType = (commit, dispatch, rootState, requestPayload, isLastResponseUser) => {
  const { messagePayload } = requestPayload
  const { text, label } = messagePayload
  const botPCIPolicy = rootState.botPCIPolicy || {}

  const shouldMask = isSensitiveDataMaskingEnabled(rootState) && !text.startsWith('event://;')
  let maskedRequestBody = requestPayload
  if (shouldMask) {
    const maskedText = maskSensitiveData(botPCIPolicy, text)

    const maskedLabel = (text !== label)
      ? maskSensitiveData(botPCIPolicy, label)
      : maskedText

    if (maskedText !== text || maskedLabel !== label) {
      maskedRequestBody = cloneDeep(requestPayload)
      maskedRequestBody.messagePayload.text = maskedText
      maskedRequestBody.messagePayload.label = maskedLabel
      commit('UPDATE_MASKED_VALUE_MAP', {
        messageId: maskedRequestBody.messagePayload.messageId,
        text,
        maskedText,
        label,
        maskedLabel
      })
    }
  }
  
  const userMessage = userMessageParser(shouldMask ? maskedRequestBody : requestPayload)
  if(Object.keys(userMessage)?.length > 0) {
    userMessage.initiator = constantStrings.WEBHOOK_HISTORY // adding initiator metadata to detect the initiator either history or new message
    if(rootState.previousCoversationLoader) {
      commit('UPDATE_PREVIOUS_CHAT', { chatBlock: userMessage })
    } 
    else {
      commit('UPDATE_CHATS', userMessage)
    }
  }
  !rootState.previousCoversationLoader && dispatch('showDayDateSeparator', requestPayload)
  if(isLastResponseUser && rootState.inputFieldTempDisableStatus) {
    dispatch('enableTempDisabledInputField')
  }
}

const processResponseTriggerType = (commit, dispatch, rootState, response, isLastBotResponse, isLastResponseBot) => {
  const isLastMessageExtension = response?.customPayload?.isLastMessageExtension || false
  const isAgentResponse = !isTypeBOT(response?.ownerType)
  response.timestamp = response.timestamp.toString()
  const botResponse = botResponseMessageParser(response, isLastBotResponse, isAgentResponse, true)
  botResponse.initiator = constantStrings.WEBHOOK_HISTORY // adding initiator metadata to detect the initiator either history or new message
  if (isLastMessageExtension) {
    botResponse.messages?.forEach((message) => {
      if (rootState.previousCoversationLoader) {
        commit('UPDATE_FIRST_CHAT_MESSAGE', message);
      } else {
        commit('UPDATE_LAST_CHAT_MESSAGE', message);
      }
    })
  } else {
    if(rootState.previousCoversationLoader) {
      commit('UPDATE_PREVIOUS_CHAT', { chatBlock: botResponse })
    } else {
      commit('UPDATE_CHATS', botResponse)
    }
  }
  if(isLastResponseBot && !(isMultiSourceLastExtension(response,botResponse.messages))) {
    const quickReplyOptions = extractQuickReplyOptions(botResponse.messages)
    dispatch('updateQuickReplyOptions', quickReplyOptions)
  }
  if(isLastBotResponse) {
    const nbaOptions = extractNBAOptions(botResponse.messages)
    if (Object.keys(nbaOptions).length) {
      const { actionableNBAOptions = [], nonActionableNBAOptions = [] } = nbaOptions
      dispatch('updateActionableNBAOptions', actionableNBAOptions)
      dispatch('updateNonActionableNBAOptions', nonActionableNBAOptions)
      if(nonActionableNBAOptions?.length){
        const urlArr = nonActionableNBAOptions.map(option=>option.url)
        let data = getUrlData({requestBody:urlArr})
        data?.then(info=>{
        const processedNbaOptions = nonActionableNBAOptions?.map((option,index)=>{
          const value= info?.[index]?.value
            const image = value?.image || value?.logo
            const longText = value?.description
            const label = value?.title
            const obj={...option,image,isProcessed:true}
            if(!obj.label && label) {
              obj.label = label
            }
            if(!obj.longText && longText) {
              obj.longText = longText
            }
          return obj
        })
        processedNbaOptions?.length && dispatch('updateNonActionableNBAOptions', processedNbaOptions)
        })?.catch(err=>{
          console.log(err)
        })
      } else {
        dispatch('updateActionableNBAOptions', [])
        dispatch('updateNonActionableNBAOptions', [])
      }
    }
  }
}

const processEventTriggerType = (response, isLastResponse) => {
  const subType = response.eventData.subType
  const event = eventParser[response.eventName]?.[response.eventData.eventType]?.[subType]
  if (event) {
    event(response.eventData.eventInfo, response.timestamp, isLastResponse, { subType })
  }
}

const validateRequiredFieldsHistoryMessages = conversationId => {
  if (!conversationId) throw Error('ConversationId not generated properly')
}

const getPreviousConversationId = (history) => {
return history?.data?.previousConversationId
}
